exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.inner-table-wrapper[data-v-ef5148dc] {\r\n    padding-left: 180px !important;\r\n    padding-right: 0 !important;\n}\n@media (max-width: 768px) {\n.inner-table-wrapper[data-v-ef5148dc] {\r\n        padding-left: 20px !important;\r\n        padding-right: 0 !important;\n}\n}\r\n", ""]);

// exports
